var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { styled } from "@material-ui/core";
import { useLinked } from "@type-r/react";
import * as React from "react";
export var DragNDropUpload = function (_a) {
    var $file = _a.$file;
    var $isDraggingOver = useLinked(false);
    var preventDefaultAndStopPropagation = function (e) {
        e.preventDefault();
        e.stopPropagation();
    };
    var onDrop = function (e) {
        preventDefaultAndStopPropagation(e);
        var file = e.dataTransfer.files ? e.dataTransfer.files[0] : null;
        $file.set(file);
        $isDraggingOver.set(false);
    };
    var onDragOver = function (e) {
        preventDefaultAndStopPropagation(e);
    };
    var onDragEnter = function (e) {
        preventDefaultAndStopPropagation(e);
        $isDraggingOver.set(true);
    };
    var onDragLeave = function (e) {
        preventDefaultAndStopPropagation(e);
        $isDraggingOver.set(false);
    };
    return (React.createElement(DropArea, { onDrop: onDrop, onDragOver: onDragOver, onDragEnter: onDragEnter, onDragLeave: onDragLeave, isDraggingOver: $isDraggingOver.value },
        React.createElement(DropIcon, { src: "../../assets/images/dragNDropUpload.png", alt: "Upload" })));
};
var DropArea = styled(function (_a) {
    var isDraggingOver = _a.isDraggingOver, rest = __rest(_a, ["isDraggingOver"]);
    return React.createElement("div", __assign({}, rest));
})({
    padding: '30px',
    backgroundColor: 'transparent',
    display: 'flex',
    justifyContent: 'center',
    border: function (props) {
        return props.isDraggingOver ? '1px solid #57bf90' : '';
    }
});
var DropIcon = styled('img')({
    width: '150px',
    height: '150px',
    pointerEvents: 'none'
});
//# sourceMappingURL=dragNDropUpload.js.map